"use client";

import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ProjectDropdown from "./ProjectDropdown";

const dropdownItems = {
  COUNTRY: [
    "SOUTH AFRICA",
    "Botswana",
    "Cameroon",
    "Congo Democratic Republic (DRC)",
    "Cote-divorie",
    "Eswatini (Swaziland)",
    "Ethiopia",
    "Ghana",
    "Kenya",
    "Lesotho",
    "Malawi",
    "Mozambique",
    "Namibia",
    "Nigeria",
    "Rwanda",
    "Senegal",
    "Sierra Leone",
    "Somalia",
    "South Africa",
    "South Sudan",
    "Tanzania",
    "Uganda",
    "Zambia",
    "Zimbabwe",
  ],
  REGION: [
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",


    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
    "GAUTENG",
  ],
  MUNICIPALITY: [
    "MUNICIPALITY1",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    "ABBATOIR",
    
  ],

  CROP: [
    "MAIZE",
    "Apples",
    "Avocado",
    "Bananas",
    "Beans",
    "Cabbages",
    "Kale",
    "Mangoes",
    "Onions",
    "Passion Fruits",
    "Papaya",
    "Potatoes",
    "Strawberries",
    "Tomatoes",
    "Watermelon",
  ],
  LIVESTOCK: [
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
    "POULTRY",
  ],
};

const Dropdown = ({ label, items, type }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(items[0]);


  return (
    <div className="flex flex-col w-full relative ">
      {/* Label */}
      <label className="md:text-[20px] font-bold text-[6px] text-black mb-1 md:mb-2">
        {label}
      </label>

      {/* Button + Icon Container */}
      <div className="flex relative z-20 w-fit">
        {/* Dropdown Button */}
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className="xl:w-[160px] lg:w-[140px] md:w-[55px] w-[45px] h-[15px] md:h-[50px] bg-[#03897B] text-white font-semibold flex justify-center items-center px-1 rounded-l-[5px]"
        >
          <span className="md:text-[18px]  text-[4px] md:mt-0 mt-[2px]">{selected}</span>
        </button>

        {/* Icon Box */}
        <div
          className="w-[15px] h-[15px] md:h-[50px] md:w-[40px] bg-[#152C24] text-white flex justify-center items-center rounded-tr-[5px]   rounded-br-[5px]  -ml-2 z-30 cursor-pointer"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
            alt="expand"
            className="w-2 h-2 md:w-6 md:h-6"
          />
        </div>
      </div>

      {/* Dropdown List */}
      {/* Dropdown List */}
      <AnimatePresence>
        {isOpen && (
          <motion.ul
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute top-full mt-1 left-0 z-50 md:w-[180px] w-[100px] bg-white/90 rounded-lg shadow-lg"
          >
            {items.map((item, index) => (
              <li
                key={index}
                onClick={() => {
                  setSelected(item);
                  setIsOpen(false);
                }}
                className="md:p-3 p-1 bg-[#CFD7D7] md:mt-1 md:text-[18px] text-[10px] rounded-md hover:bg-[#afafaf] cursor-pointer flex items-center"
              >
                <span className="text-black">{item}</span>
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>

      {/* Hint Text */}
      <p className="md:text-[14px] text-[6px] font-normal mt-1 text-black">
        Select <p className="inline lowercase">{label}</p>
      </p>

    </div>



  );
};

const ReportsSection = () => {
  return (
    <div className="mb-10 mt-2 font-Inter w-full  mx-auto">
      <div >
      <div >
<a href="Registration">
<ProjectDropdown />
</a>
    </div>
      </div>

      <div className="flex items-center md:gap-2 gap-[1px]   ">


        {Object.keys(dropdownItems).map((type) => {
          const customLabels = {
            Crop: "Crop Report",
            Livestock: "Livestock Report",
            Type: "Type of Report",
          };

          const displayLabel = customLabels[type] || type;

          return (
            <div key={type} className="w-full sm:w-auto">
              <Dropdown label={displayLabel} items={dropdownItems[type]} type={type} />
            </div>
          );
        })}
      <div>
      <p className='md:text-[20px] text-[8px]  md:mt-5  font-bold md:mb-1'>SIGN-IN</p>
      <div className="flex items-center  ml-auto   pr-3 md:pr-0 ">
                <p className="md:text-[18px] text-[4px] h-[15px] bg-[#152C24] text-white w-[40px] px-2 md:px-4 md:w-[180px] md:h-[50px] md:py-[11px] py-[6px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                VIEW MORE
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[50px] md:w-[40px] hidden md:flex object-contain md:rounded-tr-[5px] rounded-tr-md font-bold md:rounded-br-[5px] bg-[#F38323] px-2 md:py-1 "
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[15px] md:hidden flex py-[1px] md:h-[42px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#F38323] md:px-2 px-[2px] md:py-1 transition-transform duration-300 hover:rotate-45"
                />
              </div>
              <p className='md:text-[16px] text-[5px] font-light md:mb-3 mt-1'>View more</p>
      </div>
      </div>

    </div>
  );
};

export default ReportsSection;
